import 'nodelist-foreach-polyfill';
import './_index.scss';
import $, { each } from 'jquery';
import 'slick-carousel';
import "slick-carousel/slick/ajax-loader.gif";
import "slick-carousel/slick/fonts/slick.ttf";
import "slick-carousel/slick/fonts/slick.woff";
import fitvids from 'fitvids';
import 'objectFitPolyfill';
import babelPolyfill from 'babel-polyfill'; // eslint-disable-line no-unused-vars
import datepicker from 'js-datepicker';

export { Foundation as Core }       from 'foundation-sites/js/foundation.core';
import * as CoreUtils               from 'foundation-sites/js/foundation.core.utils';
export { CoreUtils };
export { Box }                      from 'foundation-sites/js/foundation.util.box';
export { onImagesLoaded }           from 'foundation-sites/js/foundation.util.imageLoader';
export { Keyboard }                 from 'foundation-sites/js/foundation.util.keyboard';
export { MediaQuery }               from 'foundation-sites/js/foundation.util.mediaQuery';
export { Motion, Move }             from 'foundation-sites/js/foundation.util.motion';
export { Nest }                     from 'foundation-sites/js/foundation.util.nest';
export { Timer }                    from 'foundation-sites/js/foundation.util.timer';
export { Touch }                    from 'foundation-sites/js/foundation.util.touch';
export { Triggers }                 from 'foundation-sites/js/foundation.util.triggers';
export { Abide }                    from 'foundation-sites/js/foundation.abide';
export { Accordion }                from 'foundation-sites/js/foundation.accordion';
export { AccordionMenu }            from 'foundation-sites/js/foundation.accordionMenu';
export { Drilldown }                from 'foundation-sites/js/foundation.drilldown';
export { Dropdown }                 from 'foundation-sites/js/foundation.dropdown';
export { DropdownMenu }             from 'foundation-sites/js/foundation.dropdownMenu';
export { Equalizer }                from 'foundation-sites/js/foundation.equalizer';
export { Interchange }              from 'foundation-sites/js/foundation.interchange';
// export { Magellan }                 from 'foundation-sites/js/foundation.magellan';
export { OffCanvas }                from 'foundation-sites/js/foundation.offcanvas';
// export { Orbit }                    from 'foundation-sites/js/foundation.orbit';
export { ResponsiveMenu }           from 'foundation-sites/js/foundation.responsiveMenu';
export { ResponsiveToggle }         from 'foundation-sites/js/foundation.responsiveToggle';
export { Reveal }                   from 'foundation-sites/js/foundation.reveal';
// export { Slider }                   from 'foundation-sites/js/foundation.slider';
export { SmoothScroll }             from 'foundation-sites/js/foundation.smoothScroll';
export { Sticky }                   from 'foundation-sites/js/foundation.sticky';
export { Tabs }                     from 'foundation-sites/js/foundation.tabs';
export { Toggler }                  from 'foundation-sites/js/foundation.toggler';
export { Tooltip }                  from 'foundation-sites/js/foundation.tooltip';
export { ResponsiveAccordionTabs }  from 'foundation-sites/js/foundation.responsiveAccordionTabs';

export { Foundation }               from 'foundation-sites/js/entries/foundation';
export { default }                  from 'foundation-sites/js/entries/foundation';

import './menus/clear-cart-modal.js'; import './menus/drilldown.js'; import './menus/meganav.js'; import './menus/menu-update.js';
import './global/plugins.js';
import './global/polyfill.js';
import './acf-page-builder/photo-gallery.js';
import './global/helper';
import './global/newsletter/newsletter-pop-up.js';

import './blocks/core-heading/heading';
import './blocks/carousel/carousel';
import './blocks/hero-feature/hero-feature';

import './global/fpo-logo.svg';
import './global/Instagram_simple_icon.png';
import './global/GiftCertificate.png';



$('.account-type-conditional').change(function() {
    conditionalFormChange(this);
    $('.qs-overlay-year').prop('required',false);
});


function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        document.querySelector('body').className += ' IE';
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        document.querySelector('body').className += ' IE';
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        document.querySelector('body').className += ' IE';
    }

    // other browser
    return false;
}
function detectIE11() {
    var ua = window.navigator.userAgent;
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        return true;
    }
    return false;
}
if($('#bc-account-register-license-expire-date').length){
    const picker = datepicker('#bc-account-register-license-expire-date', { // eslint-disable-line no-unused-vars
        formatter: (input, date) => {
            const options = { month: '2-digit', day: '2-digit',year: 'numeric' };
            const value =  date.toLocaleDateString(undefined, options);
            input.value = value;
        },
        disableMobile: true,
        customDays: ['Su', 'M', 'T', 'W', 'Th', 'F', 'Sa']
    });
    if(detectIE11()) {
        $('#bc-account-register-license-expire-date').attr('pattern', '');
    }
}



function adjustScroll() {
    $(document).on('facetwp-loaded', function() {
        $('.facetwp-template').find('.loading').remove();
        if (FWP.loaded) {
            $('html, body').animate({
                scrollTop: ($('.facetwp-template').offset().top - 50)
            }, 500);
        }
    });
    $(document).on('facetwp-refresh', function() {
        if (FWP.loaded) {
            $('.facetwp-template').prepend('<div class="loading"><div class="spinner">\n' +
                '\t<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t\t<circle class="length" fill="none" stroke-width="8" stroke-linecap="round" cx="33" cy="33" r="28"></circle>\n' +
                '\t</svg>\n' +
                '\t<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t\t<circle fill="none" stroke-width="8" stroke-linecap="round" cx="33" cy="33" r="28"></circle>\n' +
                '\t</svg>\n' +
                '\t<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t\t<circle fill="none" stroke-width="8" stroke-linecap="round" cx="33" cy="33" r="28"></circle>\n' +
                '\t</svg>\n' +
                '\t<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t\t<circle fill="none" stroke-width="8" stroke-linecap="round" cx="33" cy="33" r="28"></circle>\n' +
                '\t</svg>\n' +
                '</div></div>');
        }
    });
}


function conditionalFormChange($selectField) {

    var $selectedField = $($selectField).val(),
        $salonFields = $(".salon-only-fields"),
        $stylistFields = $(".stylist-only-fields"),
        $franchiseeFields = $(".franchisee-only-fields"),
        $gcCorpFields= $(".gc-corporate-only-fields"),
        $salonPurchaser = $(".salon-purchaser-only-fields"),
        $phoneFieldLabel = $('label[for="bc-account-register-phone"] span'),
        $phoneFieldLabel2 = $('label[for="bc-account-profile-phone"] span'),
        $salonFieldLabel = $('label[for="bc-account-register-salon-number"] span'),
        $companyFieldLabel = $('label[for="bc-account-register-company"] span'),
        $companyFieldLabel2 = $('label[for="bc-account-profile-company"] span');


    hideFields([$salonFields,$stylistFields,$franchiseeFields, $gcCorpFields, $salonPurchaser ]);
    $phoneFieldLabel
        .parent()
        .removeClass('bc-form-2col__control--left')
        .addClass('bc-form-2col__control--right');

    switch ($selectedField) {
        case 'GreatClipsCorporate':
            showField($gcCorpFields);
            $phoneFieldLabel.text('Phone Number');
            break;
        case 'Franchisee':
            showField($franchiseeFields);
            $phoneFieldLabel.text('Phone Number');
            $phoneFieldLabel2.text('Phone Number');
            $salonFieldLabel.text('Salon Number ( any salon # in your organization)');
            $companyFieldLabel.text('Company Name');
            break;
        case 'ProductPurchaser':
            showField($salonPurchaser);
            $salonFieldLabel.text('Salon Number ( any salon # in your organization)');
            $phoneFieldLabel
                .text('Phone Number')
                .parent()
                .removeClass('bc-form-2col__control--right')
                .addClass('bc-form-2col__control--left');
            break;
        default:
            showField($stylistFields);
            $phoneFieldLabel.text('Phone Number');
            $salonFieldLabel.text('Salon Number');
            $companyFieldLabel.text('Salon Name');
            $companyFieldLabel2.text('Salon Name');
    }

}

function showField($fieldGroup) {
    $fieldGroup.show();

    // Not compatible in IE 11
    $fieldGroup.find('input').prop('required',true);
    $fieldGroup.find('select').prop('required',true);

}

function hideFields($fieldArray) {
    for (var i = 0, j = $fieldArray.length; i < j; i++){
        $fieldArray[i].hide();

        //Not compatible in IE 11
        $fieldArray[i].find('input').prop('required',false);
        $fieldArray[i].find('select').prop('required',false);
    }

}




$(document).foundation();
fitvids();


$('#offCanvasRight').on('opened.zf.offcanvas', function(){
    $('body').addClass('mobile-menu--open');
    $('.site-header').addClass('is-active');
    $('.menuTrigger').addClass('is-active');

});

$('#offCanvasRight').on('closed.zf.offcanvas', function(){
    var menuEl = $('.site-header');
    $('body').removeClass('mobile-menu--open');
    $(menuEl).removeClass('is-active');

});

$('.video-reveal').on('open.zf.reveal', function(){
    var elSrc = $(this).find('iframe').attr('data-src');
    $(this).find('iframe').attr('src',elSrc);
});


var initializeProductCarousel = function( ) {
    var el = $('#productSliderJS');

    if ( el.length > 0 ) {
        el.slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            centerMode: false,
            variableWidth: false,
            focusOnSelect: true,
            adaptiveHeight: false,
            arrows: true,

            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
                {
                    breakpoint: 780,
                    settings: {
                        slidesToShow: 1,
                    }
                }]
        });
        $('.product-slider').removeClass('hidden');
    }
    $(document).resize();
};



function showVideos() {
    var el = $('.video-gallery-widget');
    if ( el.length > 0){
        el.removeClass('hidden');
    }
}


function emptyMainNavLinks() {
    $('.nav-main-link').each(function () {
        var el = $(this);
        if (el.attr('href') === '' || el.attr('href') === '#' ) {
            el.on('click', function (e) {
                e.preventDefault();
            });
        }
    });
}

$(document).on('ready',function () {
    detectIE();
    adjustScroll();
    showVideos();

    var $selectField = $(".account-type-conditional");

    if ($selectField.length) {
        conditionalFormChange($selectField);
    }
    $('.qs-overlay-year').prop('required',false);
});

$(window).on('load', function () {
    objectFitPolyfill();
    initializeProductCarousel();
    emptyMainNavLinks();
});

 //remove browser form validation on product form for bc-product-form__quantity-input field
 const quantityField = document.getElementById('quantity');
 if(quantityField) {
     quantityField.addEventListener('invalid', (function () {
         return function (e) {
             //prevent the browser from showing default error bubble / hint

             e.preventDefault();
             // optionally fire off some custom validation handler
             // myValidation();
         };
     })(), true);
 }
